import React, { useRef, useState, useEffect } from "react";
import ClearIcon from '@material-ui/icons/Clear';
import { IconButton } from "@material-ui/core";

export const Uploadfile = ({ 
  label, 
  labelKey, 
  onChange, 
  file, 
  width = 200, 
  height = 200 
}) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null);
      return;
    }
    if (typeof file === 'string') {
      setPreviewUrl(file);
      return;
    }

    if (file.imgBase64) {
      setPreviewUrl(`data:image/${file.extension};base64,${file.imgBase64}`);
      return;
    }
  }, [file]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
      onChange(labelKey, file);
    }
  };

  const handleUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleClear = () => {
    setPreviewUrl(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    onChange(labelKey, null);
  };

  return (
    <div style={{ 
      textAlign: 'center', 
      margin: '0 10px', 
      width: `${width}px`, 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center'
    }}>
      <div
        style={{
          width: `${width}px`,
          height: `${height}px`,
          border: '2px dashed #ccc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer',
          position: 'relative',
          marginBottom: '8px'
        }}
        onClick={handleUpload}
      >
        {previewUrl ? (
          <>
            <img
              src={previewUrl}
              alt="Preview"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
            <IconButton
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                handleClear();
              }}
              title="очистить"
              style={{ 
                position: 'absolute', 
                top: 0, 
                right: 0,
                backgroundColor: 'rgba(255,255,255,0.7)'
              }}
            >
              <ClearIcon />
            </IconButton>
          </>
        ) : (
          <span>Выберите файл</span>
        )}
      </div>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <label>{label}</label>
    </div>
  );
};